import { useTranslation } from 'react-i18next';
import ProfileField from '../../../components/common/ProfileField';
import Section from '../../../components/common/Section';
import type { Profile } from './model';

export interface ProfileInformationProps {
    profile: Profile;
    className?: string;
}

const ProfileInformation = ({ profile, className }: ProfileInformationProps) => {
    const { t } = useTranslation('overallTraineeReport');

    return (
        <Section title={t('sections.profile.title')} className={className} accent="muted">
            <dl className="space-y-2 text-xs">
                <ProfileField label={t('sections.profile.fields.name')} value={profile.name} />
                <ProfileField label={t('sections.profile.fields.age')} value={profile.age} />
                <ProfileField label={t('sections.profile.fields.gender')} value={profile.gender} />
                <ProfileField
                    label={t('sections.profile.fields.height')}
                    value={profile.heightCm}
                    units={t('sections.profile.units.cm')}
                />
                <ProfileField
                    label={t('sections.profile.fields.weight')}
                    value={profile.weightKg}
                    units={t('sections.profile.units.kg')}
                />
                <ProfileField label={t('sections.profile.fields.bmi')} value={profile.bmi} />
                {/* TODO: after backend support injury
                <ProfileField
                    label={t('sections.profile.fields.injury')}
                    value={profile.injury}
                    valueClassName="max-w-[110px] text-right font-medium"
                />
                */}
            </dl>
        </Section>
    );
};

export default ProfileInformation;
